// M004-F0746 (design section 7): the OCR chip of a receipt - one component for the tile and the drawer, so both always say the same thing.
// The label is the receipt's own state in words; "Reading" animates (static under prefers-reduced-motion, see the CSS) and is never colour only.
import React from 'react';
import { receiptChip, receiptStatus } from './envelopeWorkspaceModel';

export default function OcrChip({ receipt, testId }) {
  const chip = receiptChip(receipt);
  return (
    <span
      className={`ew-chip ew-chip-${chip.tone}${receiptStatus(receipt) === 'reading' ? ' ew-chip-reading' : ''}`}
      data-testid={testId}
      data-ocr={receipt?.ocr?.status || 'none'}
    >
      {chip.label}
    </span>
  );
}
